export default __webpack_public_path__ + "static/media/SimianDisplay-Chimpanzee.0825335d.woff";